import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idRoletaCheckin: string;
}

export interface RegistroAusenciaProps {
  mensagem: string;
}

export interface FilaProps {
  idUsuario: string;
  idCorretorSistemaOrigem: string;
  nomeCorretor: string;
  emailCorretor: string;
  idEquipeCorretor: string | null;
  nomeEquipeCorretor: string | null;
  dataHoraCheckin: string;
  posicao: number;
  ativo: boolean;
  bateuMao: boolean;
  registroAusencia: RegistroAusenciaProps | null;
  nomeEmpresaVendas: string;
}

export interface DataResponse {
  idRoletaCheckin: string;
  idPdv: string;
  nomePdv: string;
  codigoTurno: number;
  nomeTurno: string;
  statusFila: number;
  fila: FilaProps[];
}

export function useListarFilaRoletaCheckin(
  props: Props & QueryGlobalInterface
) {
  const fetchData = async () => {
    const LISTAR_FILA_ROLETA_CHECKIN = `${leadsWebEnviroment}/common/checkin/recepcao/listar-fila/v1?IdRoletaCheckin=${props.idRoletaCheckin}`;
    const response = await instance.get(LISTAR_FILA_ROLETA_CHECKIN);

    return (response?.data?.data as DataResponse) || null;
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: true,
    refetchInterval: 60000, // Refetch a cada 60 segundos (em milissegundos)
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar dados da Roleta ao Vivo. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}
